import React, { useState, useEffect } from 'react';
import './OrderPage.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import constants from '../Utils/constants';
import Loader from '../Components/Loader'

function OrderPage() {
    const navigate = useNavigate();
    const [orderData, setOrderData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('q');

    useEffect(() => {
        if (id) {
            fetch(`${constants.baseUrl}/OrderPage.php?q=${id}`)
                .then(response => {
                    if (!response.ok) {
                        if (response.status === 404) {
                            throw new Error('Ordine non trovato.');
                        } else if (response.status === 403) {
                            throw new Error('Non hai i permessi per accedere a questo ordine.');
                        } else {
                            throw new Error('Si è verificato un errore durante il recupero dell\'ordine.');
                        }
                    }
                    return response.json();
                })
                .then(data => {
                    setOrderData(data);
                    console.log(orderData);
                })
                .catch(error => {
                    console.error(error);
                    if (error.message === 'Ordine non trovato.') {
                      setErrorMessage('L\'ordine non è stato trovato.');
                    } else if (error.message === 'Non hai i permessi per accedere a questo ordine.') {
                      setErrorMessage('La risorsa richiesta non é al momento disponibile.');
                    } else {
                      navigate('/error');
                    }
                });
            }
        }, [id]);
    
    return (

        <div className='main-container'>
            {errorMessage ? (
                <div className='error-container'>
                    <h1>{errorMessage}</h1>
                    <h1>La invitiamo a contattarci al numero: +39 045 9400017</h1>
                </div>
            ) : !orderData ? (
                <div className='loading-position'><Loader /></div>
            ) : (
                <div className='order-wrap'>
                    <h1 className='main-title'>Riepilogo del tuo ordine</h1>
                    <div className='orders-container'>

                        <div className='order-details-container'>
                            <h1>Nr. ordine: {orderData.Numero}</h1>
                            {orderData.CIG && <h2>CIG: {orderData.CIG}</h2>}
                            {orderData.CUP && <h2>CUP: {orderData.CUP}</h2>}
                            <h2>Imponibile: {orderData.Imponibile}€</h2>
                            <h2>Data: {orderData.Data}</h2>
                        </div>

                        <hr className='separatore'></hr>

                        <div className='operator-details-container'>
                            <h2>Ordine preso in carico dall'operatore: <span className='txt'>{orderData.Operatore}</span></h2>
                            <h2>Contatto operatore: <span className='txt'>mepa@virtual-logic.it</span> <span className='txt'>{orderData.Interno ? ` - interno ${orderData.Interno}` : ''}</span></h2>
                        </div>
            
                        <div className='products-container'>
                            <div className='table-container'>
                                <table>
                                <thead>
                                    <tr>
                                    <th>Nome prodotto</th>
                                    <th>Q.tá ordinata</th>
                                    <th>Evaso</th>
                                    <th>Disponibilitá magazzino</th>
                                    <th>Importo unitario</th>
                                    <th>Importo totale</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orderData.Righe.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.Descrizione}</td>
                                        <td>{row.Quantita}</td>
                                        <td>{row.Evaso} / {row.Quantita}</td>
                                        <td>{row.Magazzino} / {row.Quantita}</td>
                                        <td>{row.Prezzo}€</td>
                                        <td>{row.PrezzoTot}€</td>
                                    </tr>
                                    ))}
                                </tbody>
                                </table>
                            </div>
                        </div>

                        <div className='curved-corner'></div>
                        <div className='curved-corner-2'></div>
                    </div>
                </div>
            )}
        </div>
      );
}

export default OrderPage;